import MainTxtH1 from './main-txt-h1';
export default MainTxtH1;
